module.exports = __webpack_public_path__ + "static/img/banner-fabric-3.fc92a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/banner/en/banner-fabric-3.jpg
// module id = 513
// module chunks = 63